import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../../../../core/maybe.js";
import { Edge as t } from "../EditGeometry.js";

var r = /*#__PURE__*/function () {
  function r(e, t) {
    var _r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, r);

    this.editGeometry = e, this.vertices = t, this.minNumberOfVertices = _r, this.removedVertices = null;
  }

  _createClass(r, [{
    key: "apply",
    value: function apply() {
      var _this = this;

      var t = "redo";
      null == this.removedVertices ? (this.removedVertices = [], this.vertices.forEach(function (t) {
        var _r2 = _this._removeVertex(t);

        e(_r2) && _this.removedVertices.push(_r2);
      }), t = "apply") : this.removedVertices.forEach(function (e) {
        _this._removeVertex(e.removedVertex);
      }), this.editGeometry.notifyChanges({
        operation: t,
        removedVertices: this.vertices
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this2 = this;

      this.removedVertices.forEach(function (e) {
        _this2._undoRemoveVertex(e);
      }), this.editGeometry.notifyChanges({
        operation: "undo",
        addedVertices: this.vertices
      });
    }
  }, {
    key: "accumulate",
    value: function accumulate() {
      return !1;
    }
  }, {
    key: "_removeVertex",
    value: function _removeVertex(e) {
      var _r3 = e.component;
      if (_r3.vertices.length <= this.minNumberOfVertices) return null;
      var i = {
        removedVertex: e,
        createdEdge: null
      },
          s = e.leftEdge,
          d = e.rightEdge;
      return _r3.vertices.splice(_r3.vertices.indexOf(e), 1), s && (_r3.edges.splice(_r3.edges.indexOf(s), 1), s.leftVertex.rightEdge = null), d && (_r3.edges.splice(_r3.edges.indexOf(d), 1), d.rightVertex.leftEdge = null), 0 === e.index && d && this.vertices.length > 0 && _r3.swapVertices(_r3.vertices.indexOf(d.rightVertex), 0), s && d && (i.createdEdge = new t(_r3, s.leftVertex, d.rightVertex), _r3.edges.push(i.createdEdge)), d && _r3.updateVertexIndex(d.rightVertex, d.rightVertex.index - 1), i;
    }
  }, {
    key: "_undoRemoveVertex",
    value: function _undoRemoveVertex(e) {
      var t = e.removedVertex,
          _r4 = e.removedVertex.component,
          i = t.leftEdge,
          s = t.rightEdge;
      e.createdEdge && _r4.edges.splice(_r4.edges.indexOf(e.createdEdge), 1), _r4.vertices.push(t), i && (_r4.edges.push(i), i.leftVertex.rightEdge = i), s && (_r4.edges.push(s), s.rightVertex.leftEdge = s), _r4.updateVertexIndex(t, t.index);
    }
  }]);

  return r;
}();

export { r as RemoveVertices };